/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    addressTitleStyle,
    addressWrapper,
} from "@monsma/App/WidgetExtensions/Addresses/SharedAddressesComponentsStylesExtension";
import { contentText, titleText } from "@monsma/App/WidgetExtensions/OrderDetails/OrderDateExtension";
import { requestRmaInformationStyles } from "@monsma/Overrides/Widgets/RequestRma/RequestRmaInformation";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

requestRmaInformationStyles.xRequestRmaInformationStyles = {
    billingAddressWrapper: {
        ...addressWrapper,
        css: css`
            ${addressWrapper.css};
            margin-top: 30px;
            width: 50%;
            min-height: auto;
            max-height: 100%;

            ${screen("lt", "sm")} {
                width: 100%;
            }
        `,
    },
};

requestRmaInformationStyles.billingInformationTitleText = addressTitleStyle;

requestRmaInformationStyles.fieldWrapper = {
    css: css`
        width: 25%;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;

        ${screen("lte", "sm")} {
            width: 50%;
        }

        ${screen("lt", "sm")} {
            width: 100%;
        }
    `,
};

requestRmaInformationStyles.titleText = titleText;

requestRmaInformationStyles.orderNumberText = contentText;
requestRmaInformationStyles.orderDateText = contentText;
requestRmaInformationStyles.customerPOText = contentText;

requestRmaInformationStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
    `,
};
